import { QueryDocumentSnapshot } from "firebase/firestore";
import { DocumentData, DocumentSnapshot } from "shared/api/firebase";
import { Article, ArticleContent } from "../types";

export class ArticlesDB {
  id: string;
  version: string;
  updatedAt: Date;
  status: string;
  createdAt: Date;
  name: string;
  content: ArticleContent | null;
  language: string;

  constructor(article: QueryDocumentSnapshot | DocumentSnapshot<DocumentData>) {
    if (!article.exists()) {
      throw new Error(`Article ${article.id} does not exist`);
    }

    const data = article.data() as Article;

    this.id = data.id;
    this.version = data.version;
    this.updatedAt = data.updatedAt;
    this.status = data.status;
    this.createdAt = data.createdAt;
    this.name = data.name;
    this.content = data.content;
    this.language = data.language;
  }

  toArticle(): Article {
    return {
      id: this.id,
      name: this.name,
      version: this.version,
      updatedAt: this.updatedAt,
      status: this.status,
      createdAt: this.createdAt,
      content: this.content,
      language: this.language,
    };
  }
}
